import { Modal, Typography } from "antd";
import { ModalProps } from "antd";
import { useState, useCallback } from "react";
import ProductCategoriesSelect from "components/common/productCategories/productCategoriesSelect";
import styled from "@emotion/styled";

const ModalWrapper = styled("div")`
  .ant-select {
    width: 100%;
  }
  .search-label {
    padding-bottom: 0.1rem;
    display: block;
  }
`;

type CategoryModalMode = "add" | "delete";

interface MultiCategoryModalProps {
  modalProps: ModalProps;
  onFinish: (data: { categoryIds: number[] }) => void;
  selectedIds: React.Key[];
  mode: CategoryModalMode;
}

export const MultiCategoryModal: React.FC<MultiCategoryModalProps> = ({ 
  modalProps, 
  onFinish, 
  selectedIds,
  mode
}) => {
  const [selectedCategoryIds, setSelectedCategoryIds] = useState<number[]>([]);

  const isAddMode = mode === "add";

  const onCategoryChange = useCallback((categoryIds: number[]) => {
    setSelectedCategoryIds(categoryIds);
  }, []);

  const handleFinish = () => {
    if (selectedCategoryIds.length === 0) {
      return;
    }
    onFinish({ categoryIds: selectedCategoryIds });
  };

  const getTitle = () => {
    return isAddMode ? "Lägg till kategorier" : "Ta bort kategorier";
  };

  const getDescription = () => {
    if (isAddMode) {
      return `Välj kategorier som ska läggas till på ${selectedIds.length} valda produkt(er). Befintliga kategorier behålls.`;
    }
    return `Välj kategorier som ska tas bort från ${selectedIds.length} valda produkt(er).`;
  };

  const getLabelText = () => {
    return isAddMode ? "Lägg till kategori" : "Välj kategorier att ta bort";
  };

  const getOkText = () => {
    return isAddMode ? "Lägg till" : "Ta bort";
  };

  return (
    <Modal
      {...modalProps}
      width={1000}
      onCancel={modalProps.onCancel}
      onOk={handleFinish}
      okText={getOkText()}
      cancelText="Avbryt"
      okButtonProps={{ disabled: selectedCategoryIds.length === 0 }}
    >
      <ModalWrapper>
        <Typography.Title level={3} style={{ marginBottom: "1rem" }}>
          {getTitle()}
        </Typography.Title>
        <Typography.Text type="secondary" style={{ display: 'block', marginBottom: '1.5rem' }}>
          {getDescription()}
        </Typography.Text>
        <Typography.Text className="search-label">{getLabelText()}</Typography.Text>
        <ProductCategoriesSelect
          categories={[]}
          onChange={onCategoryChange}
          formLoading={false}
        />
      </ModalWrapper>
    </Modal>
  );
};

// Convenience exports for backward compatibility
export const MultiAddCategoryModal: React.FC<Omit<MultiCategoryModalProps, 'mode'>> = (props) => {
  return <MultiCategoryModal {...props} mode="add" />;
};

export const MultiDeleteCategoryModal: React.FC<Omit<MultiCategoryModalProps, 'mode'>> = (props) => {
  return <MultiCategoryModal {...props} mode="delete" />;
};

